import { isClientCareerMosaic } from '@global/helpers/general';
import { Box, CircularProgress, Typography } from '@mui/material';

interface CircularProgressLabelProps {
  done: number;
  total: number;
}

function CircularProgressLabel(props: CircularProgressLabelProps) {
  const { done, total } = props;
  const loaderValue = Math.round((done / total) * 100);

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: isClientCareerMosaic() ? '#ECC21E' : 'secondary.main',
          borderRadius: '50%',
          boxShadow: isClientCareerMosaic()
            ? 'inset 0 0px 0px 6px #ffffff73'
            : 'inset 0 0 0px 6px #FFEFDC1A',
          backgroundColor: 'transparent'
        }}
        thickness={4}
        style={{
          height: '6.4rem',
          width: '6.4rem'
        }}
        value={loaderValue}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Typography sx={{ fontSize: '2.4rem', fontWeight: '700' }} color="#fff">
          {`${done}`}
          <Box component="span" sx={{ fontSize: '1.45rem', fontWeight: '500' }}>
            {`/${total}`}
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressLabel;
